var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"QrcodeManager"},[(_vm.notification)?_c('v-snackbar',{key:_vm.notification.message,attrs:{"timeout":_vm.notification.timeout,"value":true,"color":_vm.notification.type,"elevation":"24","top":"","right":""}},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }